import * as React from 'react';

import { IAuthService } from '../../services/Interfaces/IAuthService';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { AppActionCreators, ApplicationState, AppState } from '../../store';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { ScaleLoader } from 'react-spinners';
import { Button, Grid, IconButton, List, ListItem } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import { withRouter } from 'react-router';
import moment from 'moment';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import CheckIcon from '@material-ui/icons/Check';
import { IAppUserService } from '../../services/Interfaces/IAppUserService';
import { IOrganizationService } from '../../services/Interfaces/IOrganizationService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CountryCodeEnum } from '../../helpers/Constants';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { NotificationType, UserNotification } from '../../interfaces/UserNotificationsUpdate';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { NotificationItem, NotificationProps, UserNotificationProps } from '../../interfaces/Case';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICaseNewInNotificationState {}

class UserNotificationForPopUpItem extends React.PureComponent<
  UserNotificationProps,
  ICaseNewInNotificationState
> {
  private authService!: IAuthService;
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;  
  private appUserService!: IAppUserService;
  private organizationService!: IOrganizationService;

  static contextType = ApplicationContext;

  state = {} as ICaseNewInNotificationState;

  onDeleteClick = async (item: UserNotification) => {
    try {     
    this.caseService.DeleteUserNotification(item.id)
      if (this.props.onClick !== undefined) {
        this.props.onClick();
      }
    } catch (err) {
      console.log(err);
    }
  };

  onClick = async (item:UserNotification) => {
    try {
      await this.caseService.ReadUserNotification(item.id);
    }
    catch(err) {
      console.log(err);
    }
    
    switch(item.type) {
      case NotificationType.Mavo: {
        this.props.history.push('/user/auctions');
        break;
      }
      case NotificationType.Supplier: {
        this.props.history.push(`/orders/${item.subtitle}`);
        break;
      }
      default: {
        return;
      }
    }
    
  };

  getNotificationIcon(item: UserNotification): IconProp {
    switch(item.type) {
      case NotificationType.Mavo: {
        return 'hammer'
      }
      case NotificationType.Supplier: {
        return 'truck'
      }
      default:  {
        return 'exclamation';
      }
      
    }
  }

  public render() {
    this.authService = (this.context as AppContext).authenticationService;
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appUserService = (this.context as AppContext).appUserService;
    this.organizationService = (this.context as AppContext).organizationService;
    
    const item = this.props.item.entity as UserNotification;
    const index = this.props.index;
    
    return (
      <React.Fragment>
        <Grid container spacing={1}>
          <Grid item xs={1}>
            <div
              className={`p-0 ${!item.read? 'font-weight-bold' : ''}`}
            >
              {index + 1}
            </div>
          </Grid>
          <Grid item xs={3}>
            <div
              className={`text-primary justify-content-start p-0 ${!item.read? 'font-weight-bold' : '' }`}
              onClick={(e) => this.onClick(item)}
              style={{ cursor: 'pointer' }}
            >
              {item.entityId}
            </div>
            <div className={`${!item.read? 'font-weight-bold' : ''} d-flex`}
            onClick={(e) => this.onClick(item)}>
              {this.translatorService.Tranlate(item.title, item.title)}
              <FontAwesomeIcon 
                    icon={this.getNotificationIcon(item)}
                    style={{ width: 20, height: 20, marginLeft : '10px'}}
                    className="align-self-center display-1"
                />
            </div>
            <div className="font-size-sm text-black-50"
            onClick={(e) => this.onClick(item)}>
              {this.translatorService.Tranlate(item.subtitle, item.subtitle)}
            </div>
          </Grid>
            
          <Grid item xs={4}>
            <div className={!item.read? 'font-weight-bold' : ''} onClick={(e) => this.onClick(item)}>{this.translatorService.Tranlate(item.subtitle, item.subtitle)}</div>
            <div className="font-size-sm text-black-50" onClick={(e) => this.onClick(item)}>
              {this.translatorService.Tranlate(item.message, item.message)}
            </div>
          </Grid>
          <Grid item xs={3}>
            {/* <div className={'font-weight-bold'}>
              {this.props.appState.appUser?.organization?.country?.code?.toUpperCase() === CountryCodeEnum.CZ.toString() ? null : item.organizationOwner!.name}
            </div> */}
            <div className="font-size-sm text-black-50" onClick={(e) => this.onClick(item)}>
              {moment
                .utc(item.dateCreation)
                .local()
                .format(this.props.appState.longDateFormat)}
            </div>
          </Grid>
          <Grid item container direction="column" xs={1}>
            {this.props.appState.appUser?.organization?.country?.code?.toUpperCase() === CountryCodeEnum.CZ.toString() ? null : (
              <IconButton
                size="small"
                onClick={(e) => {
                  //this.handleAddToTaskList(item.id, item.caseStatus.id, true, false, true);
                }}
              >
                <StarBorderIcon fontSize="small"></StarBorderIcon>
              </IconButton>
            )}
            <IconButton
              aria-label="delete"
              color="inherit"
              className="text-danger"
              size="small"
              onClick={(e) => {
                this.onDeleteClick(item);
              }}                      
              >
              <DeleteOutlineTwoToneIcon />
            </IconButton>
          </Grid>
        </Grid>                
      </React.Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: NotificationProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  AppActionCreators,
  mergeProps
)(withRouter(UserNotificationForPopUpItem as any));
